import Box from "ds/components/Box";

import ApiKeyGroupMappingStatusBadge from "../MappingStatusBadge";
import { ApiKeyGroupMappingEntity } from "../types";

type ApiKeyGroupMappingListItemStatusCellProps = {
  group: ApiKeyGroupMappingEntity;
};

const ApiKeyGroupMappingListItemStatusCell = ({
  group,
}: ApiKeyGroupMappingListItemStatusCellProps) => {
  return (
    <Box>
      <ApiKeyGroupMappingStatusBadge status={group.status} />
    </Box>
  );
};

export default ApiKeyGroupMappingListItemStatusCell;
